// import React from 'react'

// const PurchaseApprovalPending = () => {
//   return (
//     <div>PurchaseApprovalPending</div>
//   )
// }

// export default PurchaseApprovalPending



import { Grid } from "@mui/material";
import CustomTable from "../../../../Components/Table/CustomTable";

import { useDispatch, useSelector } from "react-redux";
import { setHeaderName } from "../../../../ReduxStore/Slices/headerSlice";
// import TableDataViewModal from "../Modal/TableDataViewModal";
import actions from "../../../../ReduxStore/actions";
import TableDataViewModal from "../../../Operator/Modal/TableDataViewModal";
import ShemeApprovalModalView from "./Modal/ShemeApprovalModalView";
import { useEffect, useState } from "react";
import { format } from "date-fns";
// import { setHeaderName } from './headerSlice';

const SchemeApprovalPending = ({ setHeaderTitleName }) => {
  //   const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
  //   const UserRole = sessionStorage.getItem("UserRole");

  //    const customerId = useSelector((state) => state.customer);

  //    console.log(customerId,"customerIdcustomerIdcustomerIdcustomerId");


  // const { managementRegisterForCustomer } = useSelector(
  //   (state) => state?.managementRegisterForCustomer
  // );
  const dispatch = useDispatch();
  const { getAllPendingPlansWithCreator } = useSelector(
    (state) => state?.getAllPendingPlansWithCreator
  );


  const { approvePlan } = useSelector((state) => state?.approvePlan);
  const { rejectPlan } = useSelector((state) => state?.rejectPlan);


  console.log(getAllPendingPlansWithCreator, "getAllPendingPlansWithCreatorgetAllPendingPlansWithCreator")

  useEffect(() => {
    const data1 = {
      data: {},
      method: "get",
      apiName: "getAllPendingPlansWithCreator",
    };

    dispatch(actions.GETALLPENDINGPLANSWITHCREATOR(data1));
  }, [approvePlan, rejectPlan]);


  const [rowTableData, setRowTableData] = useState([
    {
      title: "--",
      Value: "--",
      Stake: "--",
      Maturity: "--",
      LockIn: "--",
      Closure: "--",
      ReapPercentage: "--",
      reapMonths: "--",
      Status: "--",
    },
  ]);
  //   console.log(rowTableData, "rowTableDatarowTableData");
  useEffect(() => {
    const tempArr = [];
    getAllPendingPlansWithCreator?.data?.map((data, index) => {
      return tempArr.push({
        title: data?.title,
        // Value: data?.value_of_purchase,
        // plan_id: data?.plan_id,
        // Stake: data?.purchase_stake,
        // Maturity: data?.maturity_in_months,
        // LockIn: data?.lock_in_months,
        // Closure: format(new Date(data?.closure_date), 'MMMM d, yyyy'),
        // ReapPercentage: data?.reap_percentage,
        // reapMonths: data?.reap_months,
        Value: `${data?.value_of_purchase} USD`,
        plan_id: data?.plan_id,
        Stake: `${data?.purchase_stake} g`,
        Maturity: `${data?.maturity_in_months} Months`,
        LockIn: `${data?.lock_in_months} Months`,
        Closure: format(new Date(data?.closure_date), 'MMMM d, yyyy'),
        ReapPercentage: `${data?.reap_percentage} %`,
        reapMonths: `${data?.reap_months} Months`,
        creatorRole: data?.creatorRole?.roleName,
        creator: data?.creator?.name,
        Status: `${data?.approval_status}`,
      });
    });
    setRowTableData(tempArr);
  }, [dispatch, approvePlan, rejectPlan, getAllPendingPlansWithCreator]);


  //   useEffect(() => {
  //     // setHeaderTitleName("User Registration")
  //     dispatch(setHeaderName("User Registration"));
  //   }, []);
  const tableData = [
    { title: 'Scheme 1', Value: '$1000', Stake: '13.8g', Maturity: '24 Months', LockIn: "24 Months", Closure: "15/Mar/2025", ReapPercentage: "50%", reapMonths: "12 months", Status: "Pending" },
    { title: 'Scheme 1', Value: '$1000', Stake: '13.8g', Maturity: '24 Months', LockIn: "24 Months", Closure: "15/Mar/2025", ReapPercentage: "50%", reapMonths: "12 months", Status: "Pending" },

  ];
  const tableHeadData = ['S.No', 'Title', "Value", 'Stake', 'Maturity', "Lock In", "Closure date", "Reap(%)", "Reap months", "Creator Role", "Creator Name", "Status"];


  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          // title="User List"
          title="Scheme Approval-Gold Stake"

          tableHeadData={tableHeadData}
          //   modalName={UserCreateByOperatorModal}
          allShowModal="allShowModal"
          modalVeiwName={ShemeApprovalModalView}
          //   notModalTable="notModalTable"
          //   tableEdit="tableEdit"
          tableView="tableView"
          modalViewHeadingName="Scheme Approval"
          modalHeadingName="Create User"
          // dataCreate="dataCreate"
          IsShowRejectApproveButton="IsShowRejectApproveButton"
        />
      </Grid>
    </Grid>
  );
};

export default SchemeApprovalPending;
